import { gql } from '@apollo/client'

export const CREATE_PERSON_TAG = gql`
  mutation CreatePersonTag($payload: CreatePersonTagInput) {
    createPersonTag(payload: $payload) {
      id
      tag {
        id
        name
      }
      is_active
      person {
        id
      }
    }
  }
`

export const UPDATE_PERSON_TAG = gql`
  mutation UpdatePersonTag($payload: UpdatePersonTagInput) {
    updatePersonTag(payload: $payload) {
      id
      is_active
      tag {
        id
        name
      }
    }
  }
`
